import React from "react";

const Loader = ({ color = "black" }) => {
  return (
    <div style={styles.overlay}>
      <i
        className="fa fa-spinner fa-pulse fa-3x fa-fw"
        style={{ color: color, fontSize: "40px" }}
      ></i>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed", // Covers the whole screen
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Adds a semi-transparent background
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999, // Ensures it's on top of other elements
  },
};

export default Loader;
